<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  

      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
          <!-- 活动时间 -->
          <el-form-item style="width:19%">
		        <el-date-picker
		            v-model="query.date"
		            type="daterange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd" @change="query.ischange=true" clearable style="width:100%">
		        </el-date-picker>
	        </el-form-item> 
          <!-- 活动状态 -->
          <el-form-item style="width:12%">
          	  <el-select v-model="query.status" clearable filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in statuslists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 关键字 -->
          <el-form-item>
              <el-input placeholder="请输入活动名称" v-model="query.key" @keyup.enter.native="getList" clearable @change="query.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="danger" icon="el-icon-circle-plus-outline" @click="addoffers">添加活动</el-button>
              <el-button type="warning" icon="el-icon-view" @click="checkinvitatorlog">查看任务记录（邀请人）</el-button>
              <el-button type="warning" icon="el-icon-view" @click="checkinvitateelog">查看任务记录（被邀请人）</el-button>
          </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="query.loading">
		  	    <el-table-column prop="id" label="id" width="90"></el-table-column>
	          <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column label="活动时间" width="170" align="center">
                <template slot-scope="scope">
                  <span style="float:left;width:100%">{{scope.row.time}}</span>
                  <span :style="scope.row.status=='未开始' || scope.row.status=='已结束' ? 'color:#909399;font-size:12px' : 'color:#67C23A;font-size:12px' ">{{scope.row.status}}</span>
                </template>
            </el-table-column>
            <!--
            <el-table-column prop="limittime" label="任务限定时间" width="170" align="center"></el-table-column>
            -->
	          <el-table-column prop="prizeday" label="奖品有效期" width="110" align="center"></el-table-column>
            <el-table-column label="任务类型" width="110" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.tasktype==1 ? '购买系统' : '商城下单'}}</span>
		          </template>
            </el-table-column>
            <el-table-column label="任务数量" prop="tasks" width="110" align="center"></el-table-column>
	          <el-table-column label="操作" width="135" align="center">
		          <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="新增活动任务" placement="top">
                <el-button type="danger" size="mini" icon="el-icon-plus"  circle @click="addtask(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑活动" placement="top">
		            <el-button type="warning" size="mini" icon="el-icon-edit"  circle @click="editCurrent(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除活动" placement="top">
		            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delCurrent(scope.row)"></el-button>
                </el-tooltip>
		          </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" 
              @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
      </div>


      <!-- 新增活动信息 -->
      <el-dialog title="新增 / 编辑活动" :visible.sync="addactiveDialog" width="50%" top="10vh" :before-close="closeadd" >
          <div style="width:100%;padding:0 0 5px 0;font-size:14px;border-bottom:1px solid #dddddd;margin-bottom:20px">基础信息</div>
          <el-form :inline="true" class="demo-form-inline" ref="query" :model="query" size="small">
              <el-form-item label="活动标题" label-width="120">
                  <el-input placeholder="请输入活动名称" v-model="addactives.name" clearable/>
              </el-form-item>
              <el-form-item label="活动时间" label-width="120">
                  <el-date-picker
                    size="small"
                    v-model="addactives.date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :unlink-panels="false"
                    value-format="yyyy-MM-dd HH:mm:ss" clearable>
                  </el-date-picker>
              </el-form-item>
              <!--
              <el-form-item label="任务时间" label-width="120" style="width:100%">
                  <template>
                    <el-input v-model="addactives.limittime" size="small" style="width:70%"><template slot="append">小时</template></el-input>
                    <el-tooltip class="item" effect="dark" content="领取任务后，完成任务的时间范围" placement="top">
                    <a style="position:absolute;top:7px;margin-left:15px"><img src="../../assets/question.png" style="width:20px;height:20px;"/></a>
                    </el-tooltip>
                  </template>
              </el-form-item>
              -->
              <el-form-item label="领奖时间" label-width="120" style="width:100%">
                  <template>
                    <el-input v-model="addactives.prizeday" size="small" style="width:70%"><template slot="append">天</template></el-input>
                    <el-tooltip class="item" effect="dark" content="任务完成后，往后推算设置的时间范围内属于领奖时间，超过时间奖品作废" placement="top">
                    <a style="position:absolute;top:7px;margin-left:15px"><img src="../../assets/question.png" style="width:20px;height:20px;"/></a>
                    </el-tooltip>
                  </template>
              </el-form-item>
              <el-form-item label="任务类型" label-width="120">
                  <el-select v-model="addactives.tasktype" filterable @change="changetasktype">
                      <el-option :label="item.name" :key="index" v-for="(item,index) in tasktypelists" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <quill-editor v-model="addactives.description"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @onEditorChange="onEditorchange($event)">
              </quill-editor>

              <div style="width:100%;padding:0 0 5px 0;font-size:14px;border-bottom:1px solid #dddddd;margin:40px 0 20px 0">活动分享设置</div>
              <el-form-item label="分享图片" label-width="120">
                  <template>
                      <div style="border:1px solid #dddddd;border-radius:6px;float:left;width:35px;padding:2px;">
                        <input @change="fileshareChange($event)" type="file" id="sharethumb" multiple style="display:none" />
                        <a style="float:left;width:33px;border-radius:6px;cursor:pointer" @click="changesharethumb">
                          <img :src="GLOBAL.staticUrl+addactives.showthumb" v-if="addactives.showthumb!=''" style="float:left;width:100%"/>
                          <img src="../../assets/clblog.png" v-if="addactives.showthumb==''" style="float:left;width:100%"/>
                        </a>
                      </div>
                      <el-tooltip class="item" effect="dark" content="请上传不要大于10k的图标，否则微信有可能不显示" placement="top">
                        <a style="position:absolute;top:7px;margin-left:15px"><img src="../../assets/question.png" style="width:20px;height:20px;"/></a>
                      </el-tooltip>
                  </template>
              </el-form-item>
              <el-form-item label="分享标题" label-width="120" style="width:100%">
                  <el-input placeholder="请输入活动分享标题" v-model="addactives.showtitle" clearable/>
              </el-form-item>
              <el-input type="textarea" placeholder="请输入活动分享内容" v-model="addactives.showcontent" clearable :rows="4" style="width:100%"/>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addactiveDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="saveactives">保存</el-button>
          </div>  
      </el-dialog>


      <el-dialog :title="addtaskquery.showtitle" :visible.sync="addtaskDialog" width="60%" top="10vh" :before-close="closetaskadd" >
          <!-- 任务设置 -->
          <div style="float:left;width:100%;padding:0 0 5px 0;font-size:14px;border-bottom:1px solid #dddddd;margin-bottom:20px">
            <span style="float:left;">任务设置</span>
            <el-button type="danger" size="mini" icon="el-icon-plus"  circle @click="addtaskinfos" style="float:right"></el-button>
          </div>
          <el-table :data="addtaskquery.lists">
            <el-table-column label="任务图片" align="center" width="110">
                <template slot-scope="scope">
                    <div style="margin:0 auto">
                        <input @change="filestaskChange($event)" type="file" id="taskthumb" multiple style="display:none" />
                        <a style="cursor:pointer" @click="changetaskthumb(scope.$index)">
                          <img :src="GLOBAL.staticUrl+scope.row.thumb" v-if="scope.row.thumb!=''" style="width:40px;padding:4px;border:1px solid #dddddd;border-radius:6px"/>
                          <img src="../../assets/clblog.png" v-if="scope.row.thumb==''" style="width:40px;padding:4px;border:1px solid #dddddd;border-radius:6px"/>
                        </a>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="任务名称" align="center">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.task" size="small"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="系统版本" align="center" v-if="addtaskquery.tasktype==1" width="180">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.level" filterable size="small">
                        <el-option :label="item.name" :key="index" v-for="(item,index) in levellists" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="下单金额" align="center" v-if="addtaskquery.tasktype==2" width="200">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.totals" size="small" style="width:70%"><template slot="append">元</template></el-input>
                </template>
            </el-table-column>
            <el-table-column label="任务人数" align="center" width="200">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.people" size="small" style="width:70%"><template slot="append">人</template></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="110">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看任务奖品设置" placement="top">
                    <el-button type="primary" size="mini" icon="el-icon-view"  circle @click="showtaskprize(scope.$index)"></el-button>
                    </el-tooltip>
                    <el-button type="danger" size="mini" icon="el-icon-delete"  circle @click="deltask(scope.$index)"></el-button>
                </template>
            </el-table-column>
          </el-table>

          <!-- 奖品设置 -->
          <div style="float:left;width:100%;padding:0 0 5px 0;font-size:14px;border-bottom:1px solid #dddddd;margin:60px 0 20px 0" v-if="localtaskindex >=0">
            <span style="float:left;">奖品设置</span>
            <el-button type="danger" size="mini" icon="el-icon-plus"  circle @click="addprize" style="float:right"></el-button>
          </div>
          
          <el-table :data="localprize" v-if="localtaskindex >=0">
            <el-table-column label="领奖人身份" align="center" width="230">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.prizetype" filterable size="small">
                        <el-option :label="item.name" :key="index" v-for="(item,index) in prizetypelists" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="奖品" align="left">
                <template slot-scope="scope">
                    <a style="cursor:pointer;font-size:13px" class="selectpricze" @click="addtaskprizeinfos(scope.$index)">
                      <span v-if="scope.row.goodsid=='' && scope.row.couponid==''" style="margin-top:5px">点击设置奖品</span>
                      <!-- 奖品为商品时 -->
                      <div class="selectprizeimg" style="float:left;width:65px;height:65px;padding:4px;overflow:hidden;border:1px solid #dddddd;border-radius:5px;background:rgba(221,221,221,.3)" v-if="scope.row.goodsid > 0 || scope.row.couponid > 0">
                          <a style="float:left;width:100%;height:54px;cursor:pointer;" @click.stop="changeprizethumb(scope.$index)">
                              <input @change="filesprizeChange($event)" type="file" :id="'prizethumb-'+scope.$index" multiple style="display:none" />
                              <img :src="scope.row.thumb=='' ? require('../../assets/default_img_mini.png') : GLOBAL.staticUrl+scope.row.thumb" style="float:left;width:55px;border-radius:5px" />
                          </a>
                      </div>
                      <div v-if="scope.row.goodsid > 0">
                          <div style="float:left;width:70%;margin-left:2%">
                            <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#666663;font-size:13px;line-height:23px">{{scope.row.goodsname}}</span>
                            <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#999999;font-size:12px;line-height:23px">规格：{{scope.row.propertyname}}，重量：{{scope.row.weight}}kg</span>
                            <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#999999;font-size:13px;line-height:23px;">价值：<i style="font-style:normal;color:#F56C6C;font-weight:bold">{{scope.row.price}}</i></span>
                          </div>
                      </div>
                      <!-- 奖品为优惠券时 -->
                      <div v-if="scope.row.couponid > 0">
                          <span style="float:left;width:70%;margin-left:2%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#666663;font-size:13px;line-height:23px;margin-top:15px" v-if="scope.row.discounttype==1">优惠券：买满{{scope.row.couponenenough}}减{{scope.row.couponderate}}元</span>
                          <span style="float:left;width:70%;margin-left:2%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#666663;font-size:13px;line-height:23px;margin-top:15px" v-if="scope.row.discounttype==2">优惠券：买满{{scope.row.couponenenough}}打{{scope.row.couponderate/10}}折</span>
                          <span style="float:left;width:70%;margin-left:2%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#666663;font-size:13px;line-height:23px;margin-top:15px" v-if="scope.row.discounttype==3">优惠券：买满{{scope.row.couponenenough}}件，打{{scope.row.couponderate/10}}折</span>
                      </div>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="奖品数量" align="center" width="120">
                <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.inventory"/>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="110">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" icon="el-icon-delete"  circle @click="delprize(scope.$index)"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addtaskDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="savetasks">保存</el-button>
          </div>
      </el-dialog>


      <el-dialog title="选择奖品" :visible.sync="getprizeDialog" width="60%" top="10vh" >
          <el-form :inline="true" class="demo-form-inline" ref="query" :model="query" size="small">
              <el-form-item>
                  <el-select v-model="getprizequery.prizeparam" filterable @change="changeprizeparam">
                      <el-option :label="item.name" :key="index" v-for="(item,index) in prizeparam" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item v-if="getprizequery.prizeparam==1">
                  <el-select v-model="getprizequery.brandid" placeholder="请选择品牌" @change="getprizequery.ischange=true" filterable clearable>
                      <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
	            </el-form-item>
              <el-form-item>
                  <el-input placeholder="请输入活动名称" v-model="getprizequery.key" @keyup.enter.native="getprizedata" clearable @change="getprizequery.ischange=true"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="getprizedata">查询</el-button>
              </el-form-item>
          </el-form>

          <el-tag type="danger" size="mini">注：当奖品为代金券时，其数据来源为系统代金券（类型：前端指定位置点击领取）</el-tag>

          <el-table :data="prizelists" v-loading="getprizequery.loading" style="margin-top:10px">
            <el-table-column label="商品信息" v-if="getprizequery.prizeparam==1">
                  <template slot-scope="scope">
                      <div style="float:left;width:65px;height:65px;padding:4px;overflow:hidden;border:1px solid #dddddd;border-radius:5px;background:rgba(221,221,221,.3)">
                        <img :src="scope.row.img=='' ? require('../../assets/default_img_mini.png') : GLOBAL.staticUrl+scope.row.img" style="float:left;width:55px;border-radius:5px" />
                      </div>
                      <div style="float:left;width:70%;margin-left:2%">
                        <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#666663;font-size:13px">{{scope.row.goodsname}}</span>
                        <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#999999;font-size:13px">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</span>
                        <span style="float:left;width:100%;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;color:#999999;font-size:12px">规格：{{scope.row.property_name}}</span>
                      </div>
                  </template>
            </el-table-column>
            <el-table-column label="品牌" align="center" width="120" v-if="getprizequery.prizeparam==1">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.brandname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="价格" align="center" width="120" v-if="getprizequery.prizeparam==1">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.property_price}}</span>
                </template>
            </el-table-column>
            <el-table-column label="重量（kg）" align="center" width="120" v-if="getprizequery.prizeparam==1">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.weight}}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="有效期" align="center" width="290" v-if="getprizequery.prizeparam==2">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.time}}</span>
                </template>
            </el-table-column>
            <el-table-column label="减免金额" align="center" width="200" v-if="getprizequery.prizeparam==2">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="代金券名称" align="left" v-if="getprizequery.prizeparam==2">
                <template slot-scope="scope">
                  <span style="font-size:13px">{{scope.row.discribe}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" icon="el-icon-check"  circle @click="selectprize(scope.row)"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
          <!--分页begin-->
            <el-pagination
              @size-change="pageoffersordersChange"
              @current-change="pageoffersordersCurrentChange"
              :current-page="getprizequery.p"
              :page-sizes="[10, 20, 50]"
              :page-size="getprizequery.rollpage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="prizerows">
            </el-pagination>
            <!--分页end-->
          </div>

      </el-dialog>
     
  </div>
  </transition>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    quillEditor,
  },
  data () {
    return {
        url:this.GLOBAL.domain+"Invitation/index",
        transitionshow:true,
        actionauth:'', //功能权限
        query: {
            act:'lists',
	          token:this.$cookies.get('token'),
            date:[],
            status:'',
            key:'',
            ischange:false,
            loading:false,
            p:1,
            rollpage:10,
        },
        lists:[],
        rows:10,
        statuslists:[
          {id:1,name:'未开始'},
          {id:2,name:'进行中'},
          {id:3,name:'已结束'}
        ],
        levellists:[
          {id:0,name:'专业版'},
          {id:1,name:'基础版'},
          {id:3,name:'商业版'},
          {id:5,name:'旗舰版'}
        ],
        tasktypelists:[{id:1,name:'购买系统'},{id:2,name:'商城下单'}],

        addactiveDialog:false,
        addactives: {
            act:'add',
	          token:this.$cookies.get('token'),
            id:'',
            name:'',
            description:'',
            date:[],
            limittime:'',
            prizeday:'',
            tasktype:2,
            thumb:'',
            showtitle:'',
            showcontent:'',
            showthumb:'',
            loading:false,
        },

        editorOption: { //文本框功能配置
		        placeholder: '请输入活动信息描述',
		        modules: { // 配置富文本
			        toolbar: {
				        container: [
					        ['bold', 'italic', 'underline', 'strike'],
                  ['blockquote', 'code-block'],
                  [{ 'header': 1 }, { 'header': 2 }],
                  [{ 'direction': 'rtl' }],
                  [{ 'size': ['small', false, 'large', 'huge'] }],
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'font': [] }],
                  //['image']
				        ],
                handlers: {
                  'image': function(value) {
                      if(value) {
                          document.querySelector('.addoffersfile').click();
                      }else {
                          this.quill.format('image', false);
                      }
                  }
                },
			        },
		        }
	      },


        addtaskDialog:false,
        localtaskindex:'',
        localprize:[],
        addtaskquery: {
            act:'addInvitationTask',
	          token:this.$cookies.get('token'),
            id:'',
            showtitle:'',
            tasktype:'',
            lists:[],
        },
        prizetypelists:[{id:1,name:'邀请人'},{id:2,name:'被邀请人'}],
        prizeparam:[{id:1,name:'商品'},{id:2,name:'代金券'}],
        getprizeDialog:false,
        getprizequery: {
          act:'getprizegoods',
          token:this.$cookies.get('token'),
          prizeparam:1,
          brandid:'',
          key:'',
          prizeindex:'',
          p:1,
          rollpage:10,
          loading:false,
          ischange:false,
        },
        prizelists:[],
        prizerows:0,
        brandlists:[],
        localtaskthumbindex:'',
        localtasktype:'',
        localprizethumbindex:'',
        
        
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getBrand(); //获取品牌信息
    this.getList(); //查询邀请活动信息
  },
  
  methods:{

    /** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
      this.actionauth=data;
    },
    
    //查询邀请活动信息
    getList() {
        if(this.query.ischange) {
          this.query.p=1;
          this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading = false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.rows=parseInt(res.data.count);
                this.query.loading = false;
                if(this.query.ischange) this.query.ischange=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.query.loading = false;
        });
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


    /** 新增邀请有礼活动 **/
    addoffers() {
      this.addactiveDialog=true;
      this.addactives.act="add";
      this.addactives.id='';
      this.addactives.name='';
      this.addactives.description='';
      this.addactives.date=[];
      this.addactives.limittime='';
      this.addactives.prizeday='';
      this.addactives.tasktype=2;
      this.addactives.thumb='';
      this.addactives.showtitle='';
      this.addactives.showcontent='';
      this.addactives.showthumb='';
      this.localtasktype=2;
    },


    /** 修改活动类型 **/
    changetasktype() {
        if(this.addactives.id > 0) {
            this.$confirm('警告：修改活动类型会将已设置好的活动任务以及活动任务奖品全部删除，并需要重新添加，是否需要修改 ？', { type: 'warning' }).then(() => {
                this.localtasktype=this.addactives.tasktype;
            }).catch(() => {
                this.addactives.tasktype=this.localtasktype;
            }); 
        }
    },


    /** 保存活动信息 **/
    saveactives() {
      this.$confirm('警告：请检查活动信息是否完整，活动一经设置被转发领取任务后不可再被修改，是否要保存 ？', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save(this.addactives).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.addactiveDialog=false;
                  this.getList();
                  if(this.addactives.act=="add") this.$message.success("活动添加成功，请尽快取完善任务信息"); 
              }
          }).catch((res) => {
                
          });
      }).catch(() => {
                
      }); 

    },


    //点击修改分享图片
		changesharethumb() {
			document.getElementById('sharethumb').click();
		},

    //获取修改的活动图片并上传
		fileshareChange(el) {
			var resource = this.$resource(this.GLOBAL.uploadUrl);
    		for (let i = 0; i < el.target.files.length; i++) {
				var formData = new FormData();
				formData.append('file', el.target.files[i]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
				resource.save(formData).then((res) => {
					var data=JSON.parse(Base64.decode(res.body.Data));
					if(data.Result > 0) {
						this.$message.error(data.msg);
					}else {
						this.addactives.showthumb=data.imgsrc;	
						el.target.value = ''; 				  
					}
				}).catch((res) => {
					//this.$message.error(this.GLOBAL.errortext);
				});
			}
		},

    /** 编辑活动信息 **/
    editCurrent(item) {
      this.addactiveDialog=true;
      this.addactives.act="edit";
      this.addactives.id=item.id;
      this.addactives.name='';
      this.addactives.description='';
      this.addactives.date=[];
      this.addactives.limittime='';
      this.addactives.prizeday='';
      this.addactives.tasktype=2;
      this.addactives.thumb='';
      this.addactives.showtitle='';
      this.addactives.showcontent='';
      this.addactives.showthumb='';

      var resource = this.$resource(this.url);
      resource.save({act:'info',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.addactives.name=result.name;
              this.addactives.description=result.description;
              this.addactives.date=result.date;
              this.addactives.limittime=result.limittime;
              this.addactives.prizeday=result.prizeday;
              this.addactives.tasktype=Number(result.tasktype);
              this.addactives.thumb=result.thumb;
              this.addactives.showtitle=result.showtitle;
              this.addactives.showcontent=result.showcontent;
              this.addactives.showthumb=result.showthumb;
              this.localtasktype=Number(result.tasktype);
          }
      }).catch((res) => {
            
      });
    },


    /** 删除活动信息 **/
    delCurrent(item) {
      this.$confirm('温馨提示：你是否要删除该活动 ？', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save({act:'del',token:this.$cookies.get('token'),id:item.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.getList();  
              }
          }).catch((res) => {
                
          });

      }).catch(() => {
         
      }); 
    },  
    

    /** 新增 / 编辑任务信息 **/
    addtask(item) {
        this.addtaskDialog=true;
        this.addtaskquery.showtitle=item.name+"（";
        this.addtaskquery.showtitle+=item.tasktype==1 ? '购买系统' : '商城下单';
        this.addtaskquery.showtitle+="）任务添加 / 编辑";
        this.addtaskquery.id=item.id;
        this.addtaskquery.tasktype=item.tasktype;
        this.addtaskquery.lists=[];
        this.localtaskindex=-1;
        this.addtaskquery=JSON.parse(JSON.stringify(this.addtaskquery));

          //获取活动任务信息
          var resource = this.$resource(this.url);
          resource.save({act:'getTask',token:this.$cookies.get('token'),id:item.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.addtaskquery.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.addtaskquery.lists.forEach(function(item,index) {
                      item.level=Number(item.level);
                      item.prize.forEach(function(tt,ii) {tt.prizetype=Number(tt.prizetype);});
                  });
              }
          }).catch((res) => {
                
          });
    },


    /** 保存活动任务信息 **/
    savetasks() {
      this.$confirm('警告：请检查任务信息是否完整，任务一经使用被转发领取任务后不可再被修改，是否要保存 ？', { type: 'warning' }).then(() => {
          //获取活动任务信息
          var resource = this.$resource(this.url);
          resource.save(this.addtaskquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.addtaskDialog=false;
                  this.getList();  
              }
          }).catch((res) => {
                
          });

      }).catch(() => {
                
      }); 

    },



    /** 活动添加任务信息 **/
    addtaskinfos() {
      var data={id:'',task:'',leve:'',totals:'',people:1,thumb:'',prize:[]};
      this.addtaskquery.lists.push(data);
    },

    /** 删除任务信息 **/
    deltask(index) {
      this.$delete(this.addtaskquery.lists,index);
      this.localtaskindex=-1;
      this.localprize=[];
    },


    //点击修改任务图片
		changetaskthumb(index) {
      this.localtaskthumbindex=index;
			document.getElementById('taskthumb').click();
		},

    //获取修改的活动任务图片并上传
		filestaskChange(el) {
			var resource = this.$resource(this.GLOBAL.uploadUrl);
    		for (let i = 0; i < el.target.files.length; i++) {
				var formData = new FormData();
				formData.append('file', el.target.files[i]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
				resource.save(formData).then((res) => {
					var data=JSON.parse(Base64.decode(res.body.Data));
					if(data.Result > 0) {
						this.$message.error(data.msg);
					}else {
						this.addtaskquery.lists[this.localtaskthumbindex].thumb=data.imgsrc;
						el.target.value = ''; 				  
					}
				}).catch((res) => {
					//this.$message.error(this.GLOBAL.errortext);
				});
			}
		},



    //点击修改任务奖品图片
		changeprizethumb(index) {
      this.localprizethumbindex=index;
			document.getElementById('prizethumb-'+index).click();
		},

    //获取修改任务奖品图片并上传
		filesprizeChange(el) {
			var resource = this.$resource(this.GLOBAL.uploadUrl);
    		for (let i = 0; i < el.target.files.length; i++) {
				var formData = new FormData();
				formData.append('file', el.target.files[i]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
				resource.save(formData).then((res) => {
					var data=JSON.parse(Base64.decode(res.body.Data));
					if(data.Result > 0) {
						this.$message.error(data.msg);
					}else {
						this.localprize[this.localprizethumbindex].thumb=data.imgsrc;
						el.target.value = ''; 				  
					}
				}).catch((res) => {
					//this.$message.error(this.GLOBAL.errortext);
				});
			}
		},




    /** 查看当前任务奖品设置 **/
    showtaskprize(index) {
      this.localtaskindex=index;
      this.localprize=[];
      this.localprize=this.addtaskquery.lists[index].prize;
    },

    /** 关闭新增 / 编辑活动窗口 **/
    closetaskadd() {
      this.$confirm('温馨提示：关闭当前任务添加/编辑页会导致已填写的数据丢失，您是否确定要关闭？', { type: 'warning' }).then(() => {
         this.addtaskDialog=false;
      }).catch(() => {
         this.addtaskDialog=true;
      }); 
    },

    /** 关闭任务设置窗口 **/
    closeadd() {
      this.$confirm('温馨提示：关闭当前活动添加/编辑页会导致已填写的数据丢失，您是否确定要关闭？', { type: 'warning' }).then(() => {
         this.addactiveDialog=false;
      }).catch(() => {
         this.addactiveDialog=true;
      });   
    },

    /** 新增任务奖品信息 **/
    addprize() {
      if(this.localprize.length==2) {this.$message.error("每个任务最多只能设置邀请人、被邀请人两个奖品");return false;}
      var data={prizetype:'',prize:'',goodsid:'',goodsname:'',propertyid:'',inventory:'',propertyname:'',num:'',price:'',weight:'',thumb:'',couponid:'',couponenenough:'',couponderate:''};
      this.localprize.push(data);
    },

    /** 删除任务奖品 **/
    delprize(index) {
      this.$delete(this.localprize,index);
    },


    /** 设置奖品信息 **/
    addtaskprizeinfos(index) {
        this.getprizeDialog=true;
        this.getprizequery.act="getprizegoods";
        this.getprizequery.brandid='';
        this.getprizequery.prizeparam=1;
        this.getprizequery.key='';
        this.getprizequery.prizeindex=index;
        this.getprizequery.p=1;
        this.getprizequery.rollpage=10;
        this.getprizedata();
    },

    /** 获取奖品数据信息 **/
    getprizedata() {
      if(this.getprizequery.ischange) {
        this.getprizequery.p=1;
        this.getprizequery.rollpage=10;
      }

      this.getprizequery.loading=true;
      var resource = this.$resource(this.url);
      resource.save(this.getprizequery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.getprizequery.loading = false;
            }else{
                this.prizelists = JSON.parse(Base64.decode(res.data.Data));
                //this.prizelists=JSON.parse(JSON.stringify(this.prizelists));
                this.prizerows=parseInt(res.data.count);
                this.getprizequery.loading = false;
                if(this.getprizequery.ischange) this.getprizequery.ischange=false;
            }
      }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.getprizequery.loading = false;
      });
    },
    pageoffersordersChange(val) {
        this.getprizequery.rollpage = val;
        this.getprizedata();
    },
    pageoffersordersCurrentChange(val) {
        this.getprizequery.p = val;
        this.getprizedata();
    },


    /** 修改奖品类型 **/
    changeprizeparam() {
        this.getprizequery.ischange=true;
        this.getprizequery.brandid='';
        this.getprizequery.key='';
        this.getprizequery.prizeparam==1 ? this.getprizequery.act="getprizegoods" : this.getprizequery.act="getcoupon";
        this.getprizedata();
    },

    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:1000000}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 选择商品信息 **/
    selectprize(item) {
      var data=this.localprize[this.getprizequery.prizeindex];
      if(item.goodsid) {
        data.prize=1;
        data.goodsid=item.goodsid;
        data.goodsname=item.goodsname;
        data.propertyid=item.id;
        data.propertyname=item.property_name;
        data.num=1;
        data.inventory=1;
        data.weight=item.weight;
        data.price=item.property_price;
        data.thumb=item.img;
        data.couponid='';
        data.discounttype='';
        data.couponenenough='';
        data.couponderate='';
      }else {
        data.prize=2;
        data.goodsid='';
        data.goodsname='';
        data.propertyid='';
        data.num='';
        data.inventory=1;
        data.weight='';
        data.price="";
        data.thumb='';
        data.couponid=item.couponid;
        data.discounttype=item.discounttype;
        data.couponenenough=item.usecondition;
        data.couponderate=item.edu;
      }
      this.getprizeDialog=false;
    },


    //查看邀请人任务记录
    checkinvitatorlog() {
      this.$emit('listenchild',{name:'邀请任务记录管理（邀请人）',url:'Offersinvitationlog'});
    },

    //查看被邀请人任务记录
    checkinvitateelog() {
      this.$emit('listenchild',{name:'邀请任务记录管理（被邀请人）',url:'Offersinvitateelog'});
    },


  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.selectpricze {transition:.3s all;float:left;padding:5px;border-radius:6px;width:100%}
.selectpricze:hover {background:rgba(255,255,255,1)}
.selectprizeimg {transition:.3s all;}
.selectprizeimg:hover {border:1px solid rgba(250, 194, 2) !important;box-shadow:0 0 10px rgba(250, 194, 2) !important;}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offersinvitation.vue